import { computed } from 'vue'
import { useStore } from '@/store/BookingStore'
import { useI18n } from '@/composables/useI18n'
import RouteNameEnum from '@/router/RouteNameEnum'
import checkIsPackageFlight from '@/logic/options/checkIsPackageFlight'
import checkIsPackageTrain from '@/logic/options/checkIsPackageTrain'
import shouldShowTransferTab from '@/logic/options/shouldShowTransferTab'

export interface NavbarTab {
    label: string
    value: string
    name: string
    state: string
    withUnderline: boolean
}

export default function useNavbarTabs() {
    const store = useStore()
    const { t } = useI18n()

    const navbarTabs = computed((): NavbarTab[] => {
        const booking = store.getters.getBooking;

        let tabs: NavbarTab[] = [
            {
                label: t('optionsPage.title'),
                value: '2',
                name: RouteNameEnum.OptionsV2,
                state: 'tab-grey',
                withUnderline: true,
            },
            {
                label: t('user.title'),
                value: '3',
                name: RouteNameEnum.UserInfoV2,
                state: 'tab-grey',
                withUnderline: true,
            },
            {
                label: t('paymentsPage.title'),
                value: '4',
                name: RouteNameEnum.PaymentV2,
                state: 'tab-grey',
                withUnderline: true,
            },
        ]

        if (!checkIsPackageTrain(booking) && checkIsPackageFlight(booking)) {
            tabs = [
                {
                    label: t('flightPage.title'),
                    value: '0',
                    name: RouteNameEnum.Flight,
                    state: 'tab-grey',
                    withUnderline: true,
                },
                {
                    label: t('transferPage.title'),
                    value: '1',
                    name: RouteNameEnum.Transfer,
                    state: 'tab-grey',
                    withUnderline: true,
                },
                ...tabs
            ]
        }
        if (checkIsPackageTrain(booking)) {
            const trainTabs: NavbarTab[] = [
                {
                    label: t('trainPage.title'),
                    value: '0',
                    name: RouteNameEnum.Train,
                    state: 'tab-grey',
                    withUnderline: true,
                },
            ];

            if (shouldShowTransferTab(booking)) {
                trainTabs.push({
                    label: t('transferPage.title'),
                    value: '1',
                    name: RouteNameEnum.Transfer,
                    state: 'tab-grey',
                    withUnderline: true,
                });
            }

            tabs = [...trainTabs, ...tabs];
        }

        return tabs
    })

    return {
        navbarTabs
    }
}

